import { cn } from "@/shared/utils";
import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

const dotVariants = cva("flex rounded-full", {
    variants: {
        variant: {
            emphasis: "bg-content-emphasis ",
            info: "bg-content-info",
            infoOpen: "bg-transparent border border-content-info",
            infoOpenSubtle: "bg-transparent border border-accent-blue-subtle",
            neutral: "bg-chart-neutral",
            error: "bg-content-error",
            warning: "bg-content-warning",
            succes: "bg-content-success ",
        },
        size: {
            s: "size-1",
            m: "size-2",
        },
    },
    defaultVariants: {
        variant: "emphasis",
        size: "m",
    },
});

export type DotVariants = VariantProps<typeof dotVariants>;

function Dot({ variant, size, className, ...props }: React.ComponentProps<"span"> & DotVariants) {
    return <span className={cn(dotVariants({ variant, size }), className)} {...props} />;
}

export { Dot };
